export default __webpack_public_path__ + "static/media/HUSD.ae41f145.svg";